import { message, Row, Typography } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { useDispatch, useSelector } from 'react-redux'
import BlogCard from '../../../components/BlogComponents/BlogCard'
import HeaderComponent from '../../../components/BlogComponents/HeaderComponent'
import SpinnerComponent from '../../../components/SpinnerComponent/SpinnerComponent'
import { REQUEST_LOADING_STATES } from '../../../helpers/constant'
import { getBlogs } from '../../../redux/blogs/blogSlice'
import { AppDispatch, StoreState } from '../../../redux/store'
import "./HomeBlogComponent.less"

const BLOGS_LIMIT = 9;

const HomeBlogComponent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();

  const { blogs, loading, hasMore, currentPage, error } = useSelector((state: StoreState) => state.blog)

  useEffect(() => {
    dispatch(getBlogs({ page: currentPage, offset: (currentPage - 1) * BLOGS_LIMIT, limit: BLOGS_LIMIT }));
  }, [dispatch])

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error])

  const loadBlogs = () => {
    dispatch(getBlogs({ page: currentPage + 1, offset: currentPage * BLOGS_LIMIT, limit: BLOGS_LIMIT }))
  }

  const [sentryRef] = useInfiniteScroll({
    loading: loading === REQUEST_LOADING_STATES.PENDING,
    hasNextPage: hasMore || false,
    onLoadMore: loadBlogs,
  });
  return (
    <div className='blog-wrapper'>

      <div className='blog-layout'>
        <HeaderComponent />
        <Row className='home-blog-row'>
          <Typography.Text className='home-blog-title'><span>Twizz</span>Blog</Typography.Text>

          <Typography.Text className='home-blog-subtitle'>{t("blog-subtitle")}</Typography.Text>

          {
            loading === REQUEST_LOADING_STATES.PENDING && <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <SpinnerComponent />
            </div>
          }

          {loading === REQUEST_LOADING_STATES.SUCCEEDED && blogs?.length > 0 && <Row className='home-blog-cards-row'>
            {blogs?.map((blog) => (
              <BlogCard key={blog._id} blog={blog} />
            ))}
          </Row>}

          {hasMore && <SpinnerComponent refProp={sentryRef} />}
        </Row>
      </div>
    </div>
  )
}

export default HomeBlogComponent
